import { Component, OnInit, Renderer2, OnChanges, ViewChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
declare var d3: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent{

  @Input() labels: any;
  
  
  @ViewChild('chart') private chart1Container: ElementRef;
  @ViewChild('chart2') private chart2Container: ElementRef;
  @Input() private data: Array<any>;

  private co2saving: string;
  private co2savings: Array<any>;

  private fuelcounts: any;

  private chartContainer: ElementRef;

  constructor(private renderer: Renderer2) {
  }
  ngOnInit() {
  }
  onTabsChange(event:any){
    if(event.activeId == "ngb-tab-1"){
      this.data = this.updateData(this.fuelcounts["7-days"]);
      this.co2saving = parseInt(this.co2savings["7-days"]).toString();
      setTimeout(()=>{
        this.chartContainer = this.chart1Container;
        this.createChart();
      });
    }
    if(event.activeId == "ngb-tab-0"){
      this.data = this.updateData(this.fuelcounts["last-year"]);
      this.co2saving = parseInt(this.co2savings["last-year"]).toString();
      setTimeout(()=>{
        this.chartContainer = this.chart2Container;
        this.createChart();
      });
    }
  }
  updateData(fuelcount: any){
    let p = fuelcount;
    let data = [];
    for (var key in p) {
      if (p.hasOwnProperty(key)) {
        let item = [
          this.labels[key] , parseInt(p[key])
        ]
        data.push(item);
      }
    }
    return data;
  }
  onUpdate(fuelcounts: any, cosavings: any){
    this.fuelcounts = fuelcounts;
    this.co2savings = cosavings;
    this.data = this.updateData(fuelcounts["7-days"]);
    this.co2saving = parseInt(this.co2savings["7-days"]).toString();
    setTimeout(()=>{
      this.chartContainer = this.chart1Container;
      this.createChart();
    });
  }	
  createChart() {
    if(this.chartContainer.nativeElement.children.length > 0){
      let _t = this.chartContainer.nativeElement.children[0];
      _t.remove();
    }
    const element = this.chartContainer.nativeElement;

    var margin = {top: 20, right: 20, bottom: 60, left: 40},
    width = element.offsetWidth - margin.left - margin.right,
    height = element.offsetHeight - margin.top - margin.bottom;
    var svg = d3.select(element).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")");

    var xDomain = this.data.map(d => d[0]);
    var yDomain = [0, d3.max(this.data, d => d[1])];

    var xScale = d3.scaleBand().padding(0.1).domain(xDomain).rangeRound([0, width]);
    var yScale = d3.scaleLinear().domain(yDomain).range([height, 0]);
    var xAxis = svg.append('g')
          .attr('class', 'axis axis-x')
          .style("font-size", "14px")
          .attr('transform', `translate(${margin.left}, ${margin.top + height})`)
          .call(d3.axisBottom(xScale));

    var yAxis = svg.append('g')
          .attr('class', 'axis axis-y')
          .style("font-size", "14px")
          .attr('transform', `translate(${margin.left}, ${margin.top})`)
          .call(d3.axisLeft(yScale));

    svg.selectAll('.bar')
      .data(this.data)
      .enter().append("rect")
          .attr("class", "bar")
          .attr("fill", "#BE0000")
          .attr("x", function(d) { return xScale(d[0])+margin.left; })
          .attr("y", function(d) { return yScale(d[1])+margin.top; })
          .attr("width", xScale.bandwidth())
          .attr("height", function(d) { return height - yScale(d[1]); });

          svg.append("text")
          .attr("x", -10)
          .attr("y", 0)
          .style("text-anchor", "end")
    }
    
}



// WEBPACK FOOTER //
// ./src/app/chart/home/home.component.ts